/**
 *
 * @module mediaAnalyticsKey
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef MediaAnalyticsKey
 * @type {Object}
 * @since 2.0.0
 * @desc Enumerates the known keys for media tracking data.
 * @example MediaAnalyticsKey.Conviva // 'Conviva'
 *
 * @property {String} Conviva - The "conviva" key.
 * @property {String} Telemetry - The "telemetry" key.
 *
 */

/**
 *
 * @enum
 * @type {MediaAnalyticsKey}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    Conviva: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    Telemetry: null
});



// WEBPACK FOOTER //
// ./src/media/mediaAnalyticsKey.js